import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/roboto';
import '@fontsource-variable/roboto-condensed';
import App from './App';
import { AuthProvider } from './components/AuthContext';
import './styles.css';
import './typography.css';
import './inventory-v3.css';
import './portfolio-v4.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider><App/></AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
